"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultGetTokenEditableValue = (value, meta) => {
    return `${value}`;
};
exports.default = defaultGetTokenEditableValue;
